export default __webpack_public_path__ + "static/media/location.53c78a83.svg";